import CircularProgress from '@mui/joy/CircularProgress'

export const DeterminateProgress = ({ value }) => (
    <CircularProgress determinate size="lg" value={value}>
        {value}
    </CircularProgress>
)
